import React from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';

import UserRoles from "../../../../../common/src/enums/UserRoles";
import {ROUTE_RACE, ROUTE_REPORTING} from '../../../constants/routeconstants';
import * as RaceActions from "../../../actions/race";
import * as AdminActions from "../../../actions/admin";

import RaceParticipants from "./subPages/RaceParticipants";
import RaceAccounting from "./subPages/RaceAccounting";
import RaceResults from "./subPages/RaceResults";
import RacePriceTransfers from "./subPages/RacePriceTransfers";
import RaceUnawardedPrices from "./subPages/RaceUnawardedPrices";
import RacePrices from "./subPages/RacePrices";
import RaceControl from "./subPages/RaceControl";
import GeneralMembers from "./subPages/GeneralMembers";
import GeneralJuniors from "./subPages/GeneralJuniors";
import GeneralAddresses from "./subPages/GeneralAddresses";
import GeneralRings from "./subPages/GeneralRings";
import GeneralPigeons from "./subPages/GeneralPigeons";
import GeneralLabels from "./subPages/GeneralLabels";
import GeneralLocations from "./subPages/GeneralLocations";
import SeasonChampionships from "./subPages/SeasonChampionships";
import SeasonMemberStats from "./subPages/SeasonMemberStats";
import SeasonRaceStats from "./subPages/SeasonRaceStats";
import SeasonEquipStats from "./subPages/SeasonEquipStats";
import SeasonSeats from "./subPages/SeasonSeats";
import SeasonPrices from "./subPages/SeasonPrices";
import SeasonDiplomas from "./subPages/SeasonDiplomas";

class ReportingPage extends React.Component {

    static getId() {
        return ROUTE_REPORTING;
    }

    static getAllowedRoles() {
        return [UserRoles.MAIN_ADMIN, UserRoles.SECTION_ADMIN, UserRoles.CLUB_ADMIN]; // empty means allowed for all
    }

    constructor(props) {
        super(props);
        this.state = {
            options: {}
        }
    }

    subForm = null;
    render() {
        let subPage = null;
        switch (this.props.params.category) {
            case 'general':
                switch (this.props.params.report) {
                    case 'members':
                        subPage = <GeneralMembers ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'juniors':
                        subPage = <GeneralJuniors ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'addresses':
                        subPage = <GeneralAddresses ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'rings':
                        subPage = <GeneralRings ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'pigeons':
                        subPage = <GeneralPigeons ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'labels':
                        subPage = <GeneralLabels ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'locations':
                        subPage = <GeneralLocations ref={instance => { this.subForm = instance; }}/>;
                        break;
                }
                break;
            case 'races':
                switch (this.props.params.report) {
                    case 'participants':
                        subPage = <RaceParticipants ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'accounting':
                        subPage = <RaceAccounting ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'results':
                        subPage = <RaceResults ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'price-transfers':
                        subPage = <RacePriceTransfers ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'unawarded-prices':
                        subPage = <RaceUnawardedPrices ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'prices':
                        subPage = <RacePrices ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'control':
                        subPage = <RaceControl ref={instance => { this.subForm = instance; }}/>;
                        break;
                }
                break;
            case 'season':
                switch (this.props.params.report) {
                    case 'championships':
                        subPage = <SeasonChampionships ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'member-stats':
                        subPage = <SeasonMemberStats ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'race-stats':
                        subPage = <SeasonRaceStats ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'equip-stats':
                        subPage = <SeasonEquipStats ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'seats':
                        subPage = <SeasonSeats ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'prices':
                        subPage = <SeasonPrices ref={instance => { this.subForm = instance; }}/>;
                        break;
                    case 'diplomas':
                        subPage = <SeasonDiplomas ref={instance => { this.subForm = instance; }}/>
                        break;
                    case 'performance-cards':
                        break;
                }
                break;
        }

        return (<div className="reporting-page">
            <div className="sub-page-title">
                <h2>Rapportering</h2>
            </div>
            <div className="sub-page-content">
                <div className="tab-list">
                    <Link className={this.props.params.category === 'general' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", "general").replace(":report", "members")}>
                        <span className="tab-text">Generelt</span>
                    </Link>
                    <Link className={this.props.params.category === 'races' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", "races").replace(":report", this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? "participants" : "accounting")}>
                        <span className="tab-text">Kapflyvninger</span>
                    </Link>
                    <Link className={this.props.params.category === 'season' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", "season").replace(":report", "championships")}>
                        <span className="tab-text">Årsafslutning</span>
                    </Link>
                </div>
                <div className="tab-page">
                    <div className="report-left-tabs">
                        {this.props.params.category === 'general' ? <div className="vertical-tab-list">
                            <Link className={this.props.params.report === 'members' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "members")}>
                                <span className="tab-text">Medlemslister</span>
                            </Link>
                            <Link className={this.props.params.report === 'juniors' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "juniors")}>
                                <span className="tab-text">Juniorer</span>
                            </Link>
                            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <Link className={this.props.params.report === 'addresses' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "addresses")}>
                                <span className="tab-text">Adresseliste</span>
                            </Link>}
                            {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? null : <Link className={this.props.params.report === 'rings' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "rings")}>
                                <span className="tab-text">Fodringsserier</span>
                            </Link>}
                            {this.props.auth.currentRole === UserRoles.SECTION_ADMIN.id ? null : <Link className={this.props.params.report === 'pigeons' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "pigeons")}>
                                <span className="tab-text">Duebestand</span>
                            </Link>}
                            <Link className={this.props.params.report === 'labels' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "labels")}>
                                <span className="tab-text">Labels</span>
                            </Link>
                            <Link className={this.props.params.report === 'locations' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "locations")}>
                                <span className="tab-text">Afstande og placeringer</span>
                            </Link>
                        </div> : (this.props.params.category === 'races' ? <div className="vertical-tab-list">
                            {this.props.auth.currentRole !== UserRoles.CLUB_ADMIN.id ? null : <Link className={this.props.params.report === 'participants' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "participants")}>
                                <span className="tab-text">Deltagerlister</span>
                            </Link>}
                            <Link className={this.props.params.report === 'accounting' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "accounting")}>
                                <span className="tab-text">Regnskab</span>
                            </Link>
                            <Link className={this.props.params.report === 'results' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "results")}>
                                <span className="tab-text">Resultater</span>
                            </Link>
                            {this.props.auth.currentRole === UserRoles.CLUB_ADMIN.id ? null : <Link className={this.props.params.report === 'price-transfers' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "price-transfers")}>
                                <span className="tab-text">Præmieoverførsler</span>
                            </Link>}
                            <Link className={this.props.params.report === 'unawarded-prices' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "unawarded-prices")}>
                                <span className="tab-text">Ikke udbetalte præmier</span>
                            </Link>
                            <Link className={this.props.params.report === 'prices' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "prices")}>
                                <span className="tab-text">Præmiekontoudtog</span>
                            </Link>
                            <Link className={this.props.params.report === 'control' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "control")}>
                                <span className="tab-text">Kontrollister</span>
                            </Link>
                        </div> : (this.props.params.category === 'season' ? <div className="vertical-tab-list">
                            <Link className={this.props.params.report === 'championships' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "championships")}>
                                <span className="tab-text">Mesterskaber</span>
                            </Link>
                            <Link className={this.props.params.report === 'prices' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "prices")}>
                                <span className="tab-text">Årsregnskab</span>
                            </Link>
                            <Link className={this.props.params.report === 'member-stats' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "member-stats")}>
                                <span className="tab-text">Medlemsstatistik</span>
                            </Link>
                            <Link className={this.props.params.report === 'race-stats' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "race-stats")}>
                                <span className="tab-text">Kapflyvningsstatistik</span>
                            </Link>
                            <Link className={this.props.params.report === 'equip-stats' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "equip-stats")}>
                                <span className="tab-text">Anlægsstatistik</span>
                            </Link>
                            {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <Link className={this.props.params.report === 'seats' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "seats")}>
                                <span className="tab-text">Mandatfordeling</span>
                            </Link> : null}
                            <Link className={this.props.params.report === 'diplomas' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "diplomas")}>
                                <span className="tab-text">Diplomer</span>
                            </Link>
                            {/*<Link className={this.props.params.report === 'performance-cards' ? "tab-link active" : "tab-link"} to={ROUTE_REPORTING.replace(":category", this.props.params.category).replace(":report", "performance-cards")}>
                                <span className="tab-text">Præstationskort</span>
                            </Link>*/}
                        </div> : null))}
                    </div>
                    <div className="report-page">
                        <div className="page-content">
                            {subPage}
                        </div>
                    </div>
                </div>
            </div>
            <div className="sub-page-actions">
                <span className="left-buttons">
                    <form id="html-report-form" action={"/api/report/" + this.props.params.category + '-' + this.props.params.report + "/html"} target="_blank" method="post">
                        <input type="submit" className="btn-primary" onClick={(e) => {
                            e.preventDefault();
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions();
                            if (typeof(reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof(reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) this.setState({options: reportOptions.options}, () => {
                                document.getElementById('html-report-form').submit();
                            });
                        }} value="HTML"/>
                        <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                    </form>
                    <form id="pdf-report-form" action={"/api/report/" + this.props.params.category + '-' + this.props.params.report + "/pdf"} target="_blank" method="post">
                        <input type="submit" className="btn-primary" onClick={(e) => {
                            e.preventDefault();
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions();
                            if (typeof(reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof(reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) this.setState({options: reportOptions.options}, () => {
                                document.getElementById('pdf-report-form').submit();
                            });
                        }} value="PDF"/>
                        <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                    </form>
                    <form id="csv-report-form" action={"/api/report/" + this.props.params.category + '-' + this.props.params.report + "/csv"} target="_blank" method="post">
                        <input type="submit" className="btn-primary" onClick={(e) => {
                            e.preventDefault();
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions();
                            if (typeof(reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof(reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) this.setState({options: reportOptions.options}, () => {
                                document.getElementById('csv-report-form').submit();
                            });
                        }} value="CSV"/>
                        <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                    </form>
                    <form id="excel-report-form" action={"/api/report/" + this.props.params.category + '-' + this.props.params.report + "/excel"} target="_blank" method="post">
                        <input type="submit" className="btn-primary" onClick={(e) => {
                            e.preventDefault();
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions();
                            if (typeof(reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof(reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) this.setState({options: reportOptions.options}, () => {
                                document.getElementById('excel-report-form').submit();
                            });
                        }} value="Excel"/>
                        <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                    </form>
                </span>
                <span className="right-buttons">
                    {this.props.params.category === 'races' && this.props.params.report === 'results' ? [
                        <form id="result-files-form" key={0} action={"/api/report/race-result/files"} target="_blank" method="post">
                            <input type="submit" className="btn-primary" onClick={(e) => {
                                e.preventDefault();
                                const reportOptions = this.subForm.getWrappedInstance().getReportOptions({
                                    checkOnlyRaceSelection: true
                                });
                                if (typeof (reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                    reportOptions.errors.forEach(error => {
                                        NotificationManager.error(error, 'Fejl', 10000);
                                    });
                                } else if (typeof (reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) {
                                    reportOptions.options = Object.assign(reportOptions.options, {
                                        results: {
                                            country: false,
                                            region: false,
                                            group: false,
                                            section: false,
                                            range: true,
                                        },
                                        allCalculated: true,
                                        resultSize: null,
                                        onlyJuniorsBeginners: false,
                                        onlySex: null,
                                        onlyYear: null,
                                        sectionsOrGroups: null,
                                        showPricesAndClasses: true,
                                        format: 'result-files',
                                    });
                                    this.setState({options: reportOptions.options}, () => {
                                        document.getElementById('result-files-form').submit();
                                    });
                                }
                            }} value="Resultatfiler"/>
                            <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                        </form>,
                        <form id="result-printing-form" key={1} action={"/api/report/race-result/printing"} target="_blank" method="post">
                            <input type="submit" className="btn-primary" onClick={(e) => {
                                e.preventDefault();
                                const reportOptions = this.subForm.getWrappedInstance().getReportOptions({
                                    checkOnlyRaceSelection: true
                                });
                                if (typeof (reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                    reportOptions.errors.forEach(error => {
                                        NotificationManager.error(error, 'Fejl', 10000);
                                    });
                                } else if (typeof (reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) {
                                    reportOptions.options.format = 'printing';
                                    reportOptions.options = Object.assign(reportOptions.options, {
                                        results: {
                                            country: true,
                                            region: false,
                                            group: false,
                                            section: true,
                                            range: false,
                                        },
                                        allCalculated: true,
                                        resultSize: null,
                                        onlyJuniorsBeginners: false,
                                        onlySex: null,
                                        onlyYear: null,
                                        sectionsOrGroups: null,
                                        showPricesAndClasses: true,
                                        format: 'printing',
                                    });
                                    this.setState({options: reportOptions.options}, () => {
                                        document.getElementById('result-printing-form').submit();
                                    });
                                }
                            }} value="Trykkeri"/>
                            <input type="hidden" name="options" value={JSON.stringify(this.state.options)}/>
                        </form>,
                        <button key={2} className="btn-primary" onClick={() => {
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions({
                                checkOnlyRaceSelection: true
                            });
                            if (typeof (reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof (reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) {
                                this.props.dispatch(RaceActions.calcRaces(reportOptions.options.races, () => {
                                    NotificationManager.success("Kapflyvninger genberegnet", "Alle markerede kapflyvninger er genberegnet.", 4000);
                                }))
                            }
                        }}>Beregn</button>
                    ] : null}
                    {this.props.params.category === 'season' && this.props.params.report === 'championships' ? [
                        <button key={0} className="btn-primary" onClick={() => {
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions({
                                checkOnlyChampionshipSelection: true
                            });
                            if (typeof (reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof (reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) {
                                this.props.dispatch(AdminActions.calcChampionships(reportOptions.options.championships, () => {
                                    NotificationManager.success("Mesterskaber genberegnet", "Alle markerede mesterskaber er genberegnet.", 4000);
                                }))
                            }
                        }}>Beregn</button>
                    ] : null}
                    {this.props.params.category === 'season' && this.props.params.report === 'seats' ? [
                        <button key={0} className="btn-primary" onClick={() => {
                            const reportOptions = this.subForm.getWrappedInstance().getReportOptions();
                            if (typeof (reportOptions.errors) !== 'undefined' && reportOptions.errors.length > 0) {
                                reportOptions.errors.forEach(error => {
                                    NotificationManager.error(error, 'Fejl', 10000);
                                });
                            } else if (typeof (reportOptions.isErrors) === 'undefined' || reportOptions.isErrors === false) {
                                this.props.dispatch(AdminActions.calcSeats({
                                    seatsForSection: reportOptions.options.seatsForSection,
                                    seatsForMainBoard: reportOptions.options.seatsForMainBoard,
                                }, () => {
                                    NotificationManager.success("Mandatfordeling beregnet", "Antal aktive medlemmer og mandatfordeling er beregnet for hver forening/sektion.", 4000);
                                }))
                            }
                        }}>Beregn</button>
                    ] : null}
                </span>
            </div>
        </div>);
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
});

export default connect(mapStateToProps)(ReportingPage);



// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/Reporting.js